import { useState } from 'react';
import { Action, Subject } from '@erp/authz';
import { PlusIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';
import { Button } from '@/components/ui/button';
import { useCan } from '@/hooks/useCan';
import { WorkbookCreateWizardDialog } from './WorkbookCreateWizard';

/** Opens the New workbook wizard. */
export function WorkbookCreateButton() {
  const [open, setOpen] = useState(false);
  const [canCreate] = useCan(Action.Create, Subject.Workbook);
  return (
    <>
      <Button type="button" disabled={!canCreate} onClick={() => setOpen(true)}>
        <PlusIcon />
        <T context="create workbook action">New workbook</T>
      </Button>
      <WorkbookCreateWizardDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
